import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../config/apiKey";

export const fetchSchools = createAsyncThunk(
  "schools/fetchSchools",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        "http://localhost:5010/api/adminauth/schools-list"
      );
      console.log("API response:", res.data);
      return Array.isArray(res.data) ? res.data : res.data.data;
    } catch (err) {
      console.error("Fetch schools error:", err.response || err.message);
      return rejectWithValue(err.response?.data || "Error fetching schools");
    }
  }
);
const API_BASE_URL = "https://web1024.docmaster.in:5010/school";

export const fetchQuizzes = createAsyncThunk(
  "quiz/fetchQuizzes",
  async ({ type }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/quizzes`, {
        headers: apiKeyHeader(),
        params: { type },
      });
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchLiveQuizParticipants = createAsyncThunk(
  "quiz/fetchLiveQuizParticipants",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/live-quiz-participants/${quiz_id}`,
        { headers: apiKeyHeader() }
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizParticipants = createAsyncThunk(
  "quiz/getQuizParticipants",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/quiz-participants/${quiz_id}`,
        {
          headers: apiKeyHeader(),
        }
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const schoolSlice = createSlice({
  name: "schools",
  initialState: {
    data: [],
    quizzes: [],
    liveParticipants: [],
    participants: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchools.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSchools.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchQuizzes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuizzes.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = action.payload || [];
      })
      .addCase(fetchQuizzes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLiveQuizParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLiveQuizParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.liveParticipants = action.payload;
      })
      .addCase(fetchLiveQuizParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getQuizParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.participants = action.payload || [];
      })
      .addCase(getQuizParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default schoolSlice.reducer;
